import { z } from 'zod';

/**
 * Splits comma- or whitespace-separated input into individual email tokens,
 * dropping blanks and exact duplicates while preserving order.
 */
export function parseInviteEmails(input: string): string[] {
  const seen = new Set<string>();
  const tokens: string[] = [];
  for (const raw of input.split(/[\s,]+/)) {
    const token = raw.trim();
    if (!token || seen.has(token)) continue;
    seen.add(token);
    tokens.push(token);
  }
  return tokens;
}

const singleEmailSchema = z.string().email();

/** Returns the tokens from `input` that are not valid email addresses. */
export function invalidInviteEmails(input: string): string[] {
  return parseInviteEmails(input).filter((email) => !z.validate(singleEmailSchema, email));
}
